import styled from "styled-components";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";
import { landingColors } from "@ryde/utils-landings";

export const GenericLandingWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "generic-landing-wrapper",
})`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${RASTER_LANDINGS.BgLandingOnePNG}) no-repeat;
  background-position: calc(30%) center;
  background-size: auto 100%;

  @media (min-width: 1920px), (max-height: 600px) {
    background-size: cover;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    background: white;
  }

  .landing-outside-container {
    width: 100%;
    margin: 0px;
    height: 100vh;
    padding: 100px 0px;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 0px;
      width: 100%;
    }

    .landing-container {
      margin: 0 auto;
      background: white;
      border-radius: 10px;
      border: 1px solid #b3b3b3;
      box-shadow: 6px 10px 4px 0px rgba(0, 0, 0, 0.25);
      padding: 32px;
      width: 450px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .messages-display-container {
        width: 100%;
      }

      .downloads-app-container {
        display: flex;
        align-items: stretch;
        max-height: 40px;
        justify-content: space-evenly;
        gap: 5px;

        img {
          width: 120px;
          object-fit: contain;
        }
      }

      .v-green-icon {
        @media (max-width: ${MOBILE_BREAKPOINT}) {
          margin-top: 40px;
        }
      }

      form {
        display: flex;
        flex-direction: column;
      }

      .continue-button {
        margin-top: 15px;
        align-self: center;
      }

      .address-form {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .passenger-details-list {
          margin-block: 25px;
          width: 100%;
          list-style-type: none;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;

          li > span {
            font-weight: 600;
            font-size: 18px;
            margin-inline-end: 4px;
          }
        }

        .landing-address-map-field {
        }

        .landing-accept-terms {
          margin-block: 25px;
          margin-inline-end: 11px;
          svg {
            margin-inline-end: 8px;
          }
        }
      }

      &:has(.landing-container-footer) {
        position: relative;
        padding-bottom: 120px;

        .landing-container-footer {
          border-top: 1px solid #b3b3b3;
          position: absolute;
          bottom: 0;
          height: 100px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .landing-container-footer-logo {
            width: 126px;
            height: 51px;

            background: url(${RASTER_LANDINGS.RideLogoPNG}) no-repeat center
              center;
            background-size: contain;
          }
        }
      }

      @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        box-shadow: none;
        border: none;
        gap: 8px;
        min-height: 100%;
      }
    }
  }

  .landing-logo {
    cursor: pointer;
    width: 297px;
    height: 74px;
    background: url(${RASTER_LANDINGS.JusticeLogoPNG}) no-repeat center center;
    background-size: contain;
    border: none;
    padding: 0;

    &:focus-visible {
      outline: 2px solid ${landingColors.royalPurple};
      outline-offset: 2px;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      margin-top: 0px;
      margin-bottom: 25px;
      width: 267px;
      height: 50px;
    }
  }

  .landing-top-illustration {
    height: 185px;
    width: 273px;
    margin-bottom: 16px;
    background: url(${RASTER_LANDINGS.CarFestImagePNG}) no-repeat center center;
  }

  .landing-title {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    line-height: 1.3em;
    color: ${landingColors.royalPurple};

    &.font-size-30 {
      font-size: 30px;
    }
  }

  .landing-sub-title {
    font-size: 16;
    font-weight: 400;
    text-align: center;
    color: ${landingColors.royalPurple};

    &.font-size-18 {
      font-size: 18px;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      line-height: 1.4em;
    }
  }

  .blue-link {
    color: ${landingColors.skyBlue};
    font-size: 16px;
    font-weight: 400;
    margin-top: 10px;
    border: none;
    background: transparent;
    padding: 0;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${landingColors.skyBlue};
      outline-offset: 2px;
    }
  }

  .landing-form-field {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;

    label,
    .custom-label {
      margin-top: 12px;
      font-size: 14px;
      color: ${landingColors.label};
    }

    &.hidden {
      visibility: hidden;
      height: 0;
    }
  }

  .MuiFormControl-root {
    width: 100%;

    .Mui-error {
      text-align: start;
    }
  }

  .arrow {
    transform: rotate(0deg);
  }

  .landing-info-panel {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 300px;
    background: ${landingColors.red};
    color: ${rydeColors.white};
    padding: 20px;
    overflow-y: auto;
  }

  .landing-info-panel.hidden {
    display: none;
  }

  .divider-bar {
    width: 85px;
    height: 6px;
    margin-block: 15px;
    background: ${landingColors.mintGreen};

    &.margin-top-4 {
      margin-top: 4px;
    }

    &.margin-block-30 {
      margin-block: 30px;
    }
  }

  .divider-bar-label {
    background: ${landingColors.label};
    width: 65px;
    height: 1px;
    margin-block: 5px;
  }
`;
